exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#power-map,body,html{width:100%;height:100%;margin:0;padding:0}#power-map{font-family:frutiger-medium}.PowerMapGame__power-map-game___6OQgx{position:absolute;width:100%;height:100%;top:0;left:0;background-image:url(\"img/game/map.jpg\");background-size:cover;background-position:50%;overflow:hidden}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/PowerMapGame.scss"],"names":[],"mappings":"AAAoD,qBAA1C,WAAW,YAAY,SAAS,SAAS,CAA4F,AAA3F,WAA6D,2BAA6B,CAAC,sCAAgB,kBAAkB,WAAW,YAAY,MAAM,OAAO,yCAAyC,sBAAsB,wBAA2B,eAAe,CAAC","file":"PowerMapGame.scss","sourcesContent":["html,body{width:100%;height:100%;margin:0;padding:0}:global #power-map{width:100%;height:100%;margin:0;padding:0;font-family:'frutiger-medium'}.power-map-game{position:absolute;width:100%;height:100%;top:0;left:0;background-image:url(\"img/game/map.jpg\");background-size:cover;background-position:center;overflow:hidden}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"power-map-game": "PowerMapGame__power-map-game___6OQgx",
	"powerMapGame": "PowerMapGame__power-map-game___6OQgx"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib?{"modules":true,"importLoaders":1,"sourceMap":true,"localIdentName":"[name]__[local]___[hash:base64:5]","camelCase":true,"namedExport":true,"url":false}!./node_modules/sass-loader/lib/loader.js!./src/ts/app/PowerMapGame.scss
// module id = 228
// module chunks = 0